import 'css-chunksrc/client/pages/zonesPage/projectsPage/addProjectButton/styles.scss';export default {
  "addZoneButton": "_addZoneButton_11aky_1",
  "icon": "_icon_11aky_21",
  "iconBox": "_iconBox_11aky_29"
};